import { render, staticRenderFns } from "./batch-modal.vue?vue&type=template&id=c052a40e&scoped=true"
import script from "./batch-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./batch-modal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./batch-modal.vue?vue&type=style&index=0&id=c052a40e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c052a40e",
  null
  
)

export default component.exports